import { lazy } from 'react'
import { miFormacionDisponible } from './lib/miFormacionDisponible'

/**
 * Módulo: Formación (Club Milbrands — ola 1)
 *
 * Módulos y tracks de video del Club. Una sola entidad de contenido con
 * `formato: modulo | track`: el "track del mes" es un módulo corto con vigencia,
 * no una pieza distinta (decisión de Mariano, 20-ago-2026 — evita dos
 * pipelines de video que divergen).
 *
 * Vendible por separado: un tenant puede contratar Formación sin Comunidad,
 * Eventos ni Empleo. El ítem del sidebar lo aporta el grupo `club`
 * (src/modules/club/config.js), por eso acá NO se declaran menuItems: si los
 * declarara, el ítem aparecería dos veces (una en su grupo propio y otra en el
 * grupo del Club).
 *
 * Vista admin (gestionar-contenido / programar) y vista miembro (ver) conviven
 * en el mismo módulo, gateadas por función del catálogo de permisos — mismo
 * patrón que `casos` (CasosPage vs MisCasosPage).
 *
 * Acceso: NUNCA se lee `empresa.plan` ni `empresaIds` desde este módulo. Todo
 * pasa por el resolver horizontal de entitlements (plan de la empresa habilita
 * el módulo + grants por usuario y recurso). Ver ADR rector del Club.
 */
export default {
  id: 'formacion',
  nombre: 'Formación',
  descripcion: 'Módulos y tracks de video del Club',
  icono: 'book-open',
  tipo: 'core',
  version: '0.1.0',

  // Producto para clientes desde el día uno (Ruta B) — excepción explícita al
  // default solo-staff de `.claude/patterns/modulo-nuevo.md`.
  milbrandsInterno: false,

  routes: [
    { path: 'formacion', component: lazy(() => import('./pages/FormacionPage')) },
    // «La pieza y el camino» del miembro (4-sep): módulo o programa, con
    // ?bloque= para arrancar en uno. Los candados los decide `fichaDelMiembro`.
    { path: 'formacion/ver/:tipo/:id', component: lazy(() => import('./pages/ContenidoPage')) },
    // «Mi formación» (4-sep): los logros son de la persona — avance,
    // evaluaciones y distinciones, solo lectura. Escondida fuera de DEV hasta
    // que exista su callable (lib/miFormacionDisponible.js).
    ...(miFormacionDisponible()
      ? [{ path: 'formacion/mi-formacion', component: lazy(() => import('./pages/MiFormacionPage')) }]
      : []),
    // Vista previa (staff): la ficha del alumno en pestaña propia, SIN el menú
    // del layout — por eso `public: true` (el patrón de conectar-ml/:token).
    // "Pública" acá es solo de RENDER: los datos los sirve `vistaPrevia`, que
    // exige sesión + staff del operador; sin eso la página muestra el error.
    { path: 'formacion/preview/:tipo/:id', public: true, component: lazy(() => import('./pages/PreviewPage')) },
  ],

  // Sin menuItems propios: el ítem lo aporta el grupo `club`.
  menuItems: [],

  features: [],

  permisoModulos: ['formacion'],

}
